import { inject, provideAppInitializer } from "@angular/core";
import { AppConfig } from "./app.config";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
// import { routing, appRoutingProvider } from './app.routing';
import { routing } from "./app.routing";
import { CookieService } from "ngx-cookie-service";

import { APP_BASE_HREF } from "@angular/common";

// Servicios

import { ApiAppService } from "./servicios/apiapp.service";
import { InterceptorsService } from "./servicios/interceptor.service";

// Páginas de error

import { ErrorHandler } from "@angular/core";
import { GlobalErrorHandler } from "./componentes/errores/error-handler";
import { Pagina404Component } from "./componentes/errores/pagina-404.component";
import { Pagina500Component } from "./componentes/errores/pagina-500.component";
import { ClienteNoValidoComponent } from "./componentes/errores/cliente-no-valido.component";

// Componentes App

import { AppComponent } from "./componentes/app.component";
import { HomeComponent } from "./componentes/home/home.component";
import { InfoAreasComponent } from "./componentes/informacion/infoareas.component";
import { InfoTramitesComponent } from "./componentes/informacion/infotramites.component";
import { InfoTramitesAreaComponent } from "./componentes/informacion/infotramitesarea.component";
import { PedirCitaComponent } from "./componentes/citas/pedircita.component";
import { VerCitasComponent } from "./componentes/citas/vercitas.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

// Controles angular

import { MatStepperModule } from "@angular/material/stepper";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatIconModule } from "@angular/material/icon";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatSliderModule } from "@angular/material/slider";
import { MatButtonModule } from "@angular/material/button";
import { MatRadioModule } from "@angular/material/radio";

// Validaciones de seguridad antes de enrutar una página (ficheros xxxx.routing.ts)
import { AuthenticationGuard } from "./authentication.guard";
import { JwtModule, JwtModuleOptions } from "@auth0/angular-jwt";
import { ServicioToken } from "./shared/decodeToken";
import { ServicioAuth } from "./shared/auth/services/auth.service";
import { RequestInterceptorService } from "./shared/auth/services/jwt.authorization";
import { WINDOW_PROVIDERS } from "./shared/auth/url-api";

export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load();
}

const JWT_Module_Options: JwtModuleOptions = {
  config: {
    tokenGetter: () => {
      if (localStorage.getItem("AccessToken")) {
        return localStorage.getItem("AccessToken");
      } else {
        return null;
      }
    },
  },
};

@NgModule({ declarations: [
        AppComponent,
        Pagina404Component,
        Pagina500Component,
        ClienteNoValidoComponent,
        HomeComponent,
        PedirCitaComponent,
        VerCitasComponent,
        InfoAreasComponent,
        InfoTramitesComponent,
        InfoTramitesAreaComponent,
    ],
    bootstrap: [AppComponent], imports: [FormsModule,
        routing,
        BrowserModule,
        BrowserAnimationsModule,
        MatStepperModule,
        MatSlideToggleModule,
        MatIconModule,
        MatExpansionModule,
        MatSliderModule,
        MatButtonModule,
        MatRadioModule,
        JwtModule.forRoot(JWT_Module_Options)], providers: [
        WINDOW_PROVIDERS,
        AuthenticationGuard,
        CookieService,
        ApiAppService,
        ServicioToken,
        ServicioAuth,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RequestInterceptorService,
            multi: true,
        },
        AppConfig,
        provideAppInitializer(() => {
        const initializerFn = (initializeApp)(inject(AppConfig));
        return initializerFn();
      }),
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
